import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";

// Owner
import DashboardLayout from "../pages/Layout";
import RestaurantDashboard from "../pages/RestaurantDashboard";
import MenuPanel from "../pages/MenuPanel";
import OrderPage from "../pages/OrderPage";
import Support from "../pages/Support";
import MenuEditor from "../pages/MenuEditor";
import RestaurantSettings from "../pages/RestaurantSettings";
import RestaurantProfile from "../pages/RestaurantProfile";
import MenuSettings from "../components/MenuSettings";
import PricingDashboard from "../pages/PricingDashboard";
import ReportData from "../pages/ReportData";
import UnderDevelopment from "../components/UnderDevelopment";
import CustomerClub from "../pages/CustomerClub";
import RequireFeature from "../components/plan/RequireFeature";
import { PLAN_FEATURE } from "../config/planEntitlements";

const LegacyMenuPanelRedirect = () => {
  const location = useLocation();
  return <Navigate to={`/dashboard/menu${location.search}`} replace />;
};

const ProtectedRoutes = () => {
  const { user } = useContext(UserContext);

  if (!user) return <Navigate to="/auth/restaurant" replace />;

  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route index element={<RestaurantDashboard />} />
        <Route path="menu" element={<MenuPanel />} />
        <Route path="panel" element={<LegacyMenuPanelRedirect />} />
        <Route path="orders" element={<OrderPage />} />
        {/* Reservations are still under development — blocked here regardless
            of subscription plan. The plan-based RequireFeature/PLAN_FEATURE
            gating (components/plan/RequireFeature.jsx) can be swapped back in
            once the feature is finished, as the customer club below does. */}
        <Route
          path="reservations"
          element={<UnderDevelopment title="رزرو آنلاین میز" message="سیستم رزرو آنلاین، نقشه سالن و نمای زنده هنوز در حال توسعه است." />}
        />
        <Route path="pricing" element={<PricingDashboard />} />
        <Route
          path="club"
          element={
            <RequireFeature
              feature={PLAN_FEATURE.CUSTOMER_CLUB}
              title="باشگاه مشتریان"
              message="باشگاه مشتریان، پروفایل و سابقه مشتری‌ها در بسته حرفه‌ای و بالاتر فعال است."
            >
              <CustomerClub />
            </RequireFeature>
          }
        />
        <Route path="report" element={<ReportData />} />
        <Route path="report/:menuId" element={<Navigate to="/dashboard/report" replace />} />
        <Route path="support" element={<Support />} />
        <Route path="support/:ticketId" element={<Support />} />
        <Route path="edit-menu" element={<MenuEditor />} />
        <Route path="edit-menu/:menuId" element={<MenuEditor />} />
        <Route path="settings/:restaurantId" element={<RestaurantSettings />} />
        <Route path="profile/:restaurantId" element={<RestaurantProfile />} />
        <Route path="menu-settings/:menuId" element={<MenuSettings />} />
      </Route>
    </Routes>
  );
};


export default ProtectedRoutes;
